function submit_checkout() {
  console.log("Called", $('#custom_check').attr('class').includes('rale-checkout--invisible'))
  if (!$('#custom_check').attr('class').includes('rale-checkout--invisible')) {
      fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        var cartData   =  data;  
        var cartItems  =  cartData.items;
        var forminputs =  '';
    
        cartItems.forEach(function(cart_item, key){      
          var propval = '';
          
          if ("Date" in cart_item.properties) {
            propval = cart_item.properties.Date;  
          }
          forminputs += 'vid['+key+']='+cart_item.variant_id+'&pid['+key+']='+cart_item.product_id+'&Qty['+key+']='+cart_item.quantity+'&prop['+key+']='+propval+'&';
          console.log(cart_item, key);
        })
        window.location.href = 'https://checkout.thestrandsd.host/index.php?'+forminputs
        console.log(forminputs)
        
      })
      .catch(error => {
        console.error('Error retrieving cart data:', error);
      });    
  }

}

function submit_shopify_checkout() {
    const cb = document.querySelector(".rale-checkbox input");
    if (cb && cb.checked) {
       window.location.href = '/checkout';
    }
}